import React from 'react';
import PlotlyChart from '../../../components/charts/PlotlyChart';

const IndicatorPanel = ({ title, traces, refLines = [], height = 220, yFormat = '.2f' }) => {
  if (!traces || traces.length === 0) return null;
  const dates = traces[0]?.x;
  if (!dates || dates.length === 0) return null;

  const shapes = refLines.map((rl) => ({
    type: 'line',
    xref: 'paper', x0: 0, x1: 1,
    y0: rl.y, y1: rl.y,
    line: { color: rl.color || '#94a3b8', width: 1, dash: 'dot' },
  }));
  const annotations = refLines
    .filter((rl) => rl.label)
    .map((rl) => ({
      xref: 'paper', x: 1.0, xanchor: 'right',
      y: rl.y, yanchor: 'bottom',
      text: rl.label, showarrow: false,
      font: { color: rl.color || '#94a3b8', size: 9 },
    }));

  return (
    <div>
      <div className="text-[10px] uppercase tracking-[2px] text-gray-400 mb-2">{title}</div>
      <PlotlyChart
        data={traces}
        layout={{
          height,
          margin: { l: 50, r: 40, t: 10, b: 30 },
          shapes,
          annotations,
          yaxis: { tickformat: yFormat },
          showlegend: traces.length > 1,
        }}
      />
    </div>
  );
};

export default IndicatorPanel;
